import type { ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  text: string;
}

export const IconPill = ({ text, icon }: Props) => (
  <div className="vai-border vai-border-zinc-800 vai-bg-zinc-700 vai-text-zinc-50 vai-rounded-full vai-py-[2px] vai-px-3 vai-inline-flex vai-justify-center vai-items-center vai-gap-2">
    <p className="vai-font-inter vai-text-xs vai-font-semibold">{text}</p>
    {icon}
  </div>
);
